import { useEffect } from 'react'
import {
  useAppSelector,
  useAppDispatch,
} from 'srs.sharedcomponents/lib/esm/redux/hooks'
import { getItemsCountFromDB } from 'srs.sharedcomponents/lib/esm/redux/slices/cartSlice'
import { selectWishListMode } from 'srs.sharedcomponents/lib/esm/redux/slices/wishlistSlice'
import {
  BusinessRegion,
  LinkType,
  RoleEnum,
  wishListDbInteractions,
} from 'srs.sharedcomponents/lib/esm/utils/enums'
import { HeaderMobile } from './mobile'
import { HeaderWeb } from './web'

import useCartConditions from 'srs.sharedcomponents/lib/esm/hooks/useCartConditions'
import { mainMenuItems } from 'srs.sharedcomponents/lib/esm/redux/slices/welcomeSlice'
interface HeaderProps {
  toggleLeftSideMobileMenu?: () => void
}

export interface CustomHeaderProps extends HeaderProps {}

const HeaderLayoutComponent = (props: CustomHeaderProps) => {
  const { ...rest } = props
  const menuItems = useAppSelector(mainMenuItems)
  const user = useAppSelector((state) => state.user.user)
  const welcome = useAppSelector((state) => state.welcome.welcome)

  const getLogoTextForRegion = (businessRegion?: string): string => {
    switch (businessRegion) {
      case BusinessRegion.EMEA:
        return 'litLogoTextEMEA'
      case BusinessRegion.LAM:
      case BusinessRegion.Brazil:
        return ''
      case BusinessRegion.APAC:
      case BusinessRegion.Australia:
      case BusinessRegion.China:
      case BusinessRegion.India:
        return 'litLogoText'
      default:
        return 'litLogoTextEMEA'
    }
  }

  const regionLogoText = getLogoTextForRegion(
    user?.region?.shortName || welcome?.region?.shortName,
  )
  const toolNetLink = Array.isArray(menuItems)
    ? menuItems.find((item) => item.linkType === LinkType.ToolNet)
    : undefined

  const isInventoryAdministrator = user?.userRoles?.find(
    (role) => role.roleId === RoleEnum.InventoryAdministrator,
  )

  const wishListMode: wishListDbInteractions =
    useAppSelector(selectWishListMode)
  const dispatch = useAppDispatch()

  useEffect(() => {
    //after moveFromWishListToCart
    if (wishListMode === wishListDbInteractions.moveToCartFulfilled)
      dispatch(getItemsCountFromDB())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wishListMode])

  useCartConditions()

  return (
    <>
      <HeaderWeb
        {...rest}
        toolNetLink={toolNetLink}
        isInventoryAdministrator={!!isInventoryAdministrator}
        regionLogoText={regionLogoText}
      />
      <HeaderMobile
        {...rest}
        toolNetLink={toolNetLink}
        isInventoryAdministrator={!!isInventoryAdministrator}
        regionLogoText={regionLogoText}
      />
    </>
  )
}

export default HeaderLayoutComponent
